// frontend/src/components/capacitor/CapacitorHandoff.tsx
import { useEffect, useState } from 'react'
import axios from 'axios'
import { Capacitor } from '@capacitor/core'
import { QRCodeSVG } from 'qrcode.react'
import './Capacitor.css'

const API_BASE = Capacitor.isNativePlatform() ? 'https://chatarchiv.de' : ''

interface Props {
  jobId: string
  onBack: () => void
}

interface HandoffData {
  code: string
  expires_at: string
}

export function CapacitorHandoff({ jobId, onBack }: Props) {
  const [handoff, setHandoff] = useState<HandoffData | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    axios
      .post(`${API_BASE}/api/handoff/generate`, { job_id: jobId })
      .then((r) => setHandoff(r.data))
      .catch(() => setError('Code konnte nicht erstellt werden.'))
  }, [jobId])

  const expiresInHours = handoff
    ? Math.max(0, Math.round(
        (new Date(handoff.expires_at).getTime() - Date.now()) / 3_600_000
      ))
    : null

  const qrValue = handoff
    ? `https://chatarchiv.de/?code=${handoff.code}`
    : ''

  return (
    <div className="cap-handoff">
      <div className="cap-handoff-header">
        <button type="button" className="cap-handoff-back" onClick={onBack}>←</button>
        <span className="cap-handoff-title-text">Auf Desktop wechseln</span>
      </div>

      <p className="cap-handoff-instruction">
        chatarchiv.de im Browser öffnen und diesen Code eingeben — dein Chat wird übertragen,
        alle Optionen sind verfügbar.
      </p>

      {error && (
        <p style={{ color: '#ef4444', fontSize: 14, textAlign: 'center' }}>{error}</p>
      )}

      {handoff ? (
        <>
          <div className="cap-handoff-code">{handoff.code}</div>

          {expiresInHours !== null && (
            <p className="cap-handoff-expiry">Gültig für {expiresInHours} Stunden</p>
          )}

          <QRCodeSVG
            value={qrValue}
            size={180}
            bgColor="#ffffff"
            fgColor="#0f172a"
          />

          <p style={{ fontSize: 12, color: '#94a3b8', textAlign: 'center' }}>
            QR-Code scannen oder Code manuell eingeben
          </p>
        </>
      ) : !error ? (
        <p style={{ color: '#94a3b8', fontSize: 14 }}>Code wird erstellt…</p>
      ) : null}
    </div>
  )
}
